import BaseApiService from '../BaseApiService';
import WebEnvConfig from '@/models/WebEnvConfig';
import SmartExchangeRequest from '@/models/requests/SmartExchangeRequest';
import IFeedData from '@/models/comp/IFeedData';
import CompAddressUtils from '@/models/comp/CompAddressUtils';
import IServiceHelper from './IServiceHelper';
import ServiceHelperFactory from './ServiceHelperFactory';
import _FakePayload from './_FakeCompPayload';
import { SourceDataInitials } from '@/constants/SourceDataInitials';
import theLocalStorageUtils from '@/utils/LocalStorageUtils';
import { isFakeDataHostnameAllowed } from '@/constants/FakeDataHostnames';
import LocalCompRequest from '@/models/requests/LocalCompRequest';

export default class LocalCompService extends BaseApiService {
    private readonly currentHostname: string;

    constructor(webEnvConfig: WebEnvConfig) {
        super(webEnvConfig.urls?.quickSourceApi ?? '');
        this.currentHostname = String(webEnvConfig.hostname || '').toLowerCase();
    }

    getServiceHelper(): IServiceHelper {
        return ServiceHelperFactory.getHelper();
    }

    async getBestComp(request: LocalCompRequest): Promise<any | null> {
        this.addContentTypeJsonHeader();
        this.addAcceptJsonHeader();
        //this.setLogRequest(true);

        try {
            const response = await this.axiosInstance.post('v7/DataDiscrepancy/LocalBestComp', request);
            
            // This is a check to see if we should load fake data for testing purposes.  
            // Only localhost and dev environments are allowed to load fake data.
            if (
                isFakeDataHostnameAllowed(this.currentHostname) &&
                theLocalStorageUtils.hasKey('load-fake-data') &&
                theLocalStorageUtils.get('load-fake-data')
            ) {
                if(request.isSubject) {
                    return _FakePayload.loadFakeData(SourceDataInitials.Database, true);
                } else {
                    return _FakePayload.loadFakeData(SourceDataInitials.Database, false);
                }
            } else {
                if (response.data) {
                    if (response.status === 200) {
                        return response.data;
                    }
                } else {
                    throw new Error(`LocalCompService.getBestComp(), No data returned from endpoint for address[${CompAddressUtils.getDescription(request.address)}], isSubject[${request.isSubject}], formCode[${request.formCode}]`);
                }
            }
            
        } catch (error) {
            const errorDescription = this.getErrorDescription(error);
            const addressDescription = CompAddressUtils.getDescription(request.address);
            //console.log(`LocalCompService.getBestComp(), Error[${errorDescription}] on address[${addressDescription}], isSubject[${request.isSubject}], formCode[${request.formCode}]`);
        }

        return null;
    }

    async getSubComps(request: LocalCompRequest): Promise<any[] | null> {
        this.addContentTypeJsonHeader();
        this.addAcceptJsonHeader();
        //this.setLogRequest(true);

        try {
            const data = JSON.stringify(request);

            const response = await this.axiosInstance.post('v7/DataDiscrepancy/LocalComps', data);
            if (response.status === 200) {
                const result: IFeedData[] = response.data;
                return result;
            }
        } catch (error) {
            const errorDescription = this.getErrorDescription(error);
            const addressDescription = CompAddressUtils.getDescription(request.address);
            console.log(`LocalCompService.getSubComps(), Error[${errorDescription}] on address[${addressDescription}], comps Guid[${request.compsGuid}]`);
        }
        return null;
    }
}
